import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Switch } from "../ui/switch";
import { Button } from "../ui/button";
import { useLang } from "../../lib/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";

const AgeVerification = ({ onVerify }) => {
  const { t } = useLang();
  const [agreed, setAgreed] = useState(false);

  return (
    <div className="age-gate-backdrop" data-testid="age-verification-gate">
      <div className="absolute top-6 right-6 z-10">
        <LanguageSwitcher />
      </div>
      <div className="age-gate-card animate-fade-in-up">
        <div className="mb-6">
          <AlertTriangle className="w-16 h-16 mx-auto text-secondary mb-4" />
          <h2 className="text-2xl font-bold text-center">{t('ageTitle')}</h2>
          <p className="text-text-secondary text-center mt-2">{t('ageDescription')}</p>
        </div>

        <div className="bg-surface-highlight p-4 rounded-xl mb-6 text-sm text-text-secondary space-y-2">
          <p>{t('ageEntering')}</p>
          <p>• {t('ageOver18')}</p>
          <p>• {t('ageConsent')}</p>
          <p>• {t('ageAI')}</p>
        </div>

        <div className="flex items-center gap-3 mb-6">
          <Switch checked={agreed} onCheckedChange={setAgreed} data-testid="age-verify-switch" />
          <span className="text-sm font-medium">{t('ageConfirm')}</span>
        </div>

        <Button onClick={onVerify} disabled={!agreed} className="w-full bg-gradient-to-r from-primary to-secondary hover:opacity-90 py-6 disabled:opacity-30" data-testid="age-verify-btn">
          {t('ageEnter')}
        </Button>
      </div>
    </div>
  );
};

export default AgeVerification;
